import React from 'react';
import PropTypes from 'prop-types';
// import moment from 'moment';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Collapse,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Divider,
} from '@material-ui/core';

import ListMdaItem from '../ListMda/ListMdaItem';

const ListMdaClient = ({
  data,
  isLoading,
}) => {
  const [arr, setArr] = React.useState([]);

  const initMda = (_mda) => {
    const array = [..._mda];
    let _arr = [];
    const labelArr = array.map(x => (x.entity_label));
    labelArr.forEach((x) => {
      if (!(_arr.includes(x))) {
        _arr = [..._arr, x];
      }
    });
    const mdaArr = _arr.map(x => ({
      entity_label: x,
      createdtime: array.filter(el => el.entity_label === x)[0].createdtime,
      de_documentoid_label: array.filter(el => el.entity_label === x)[0].de_documentoid_label,
      a_documentoid_label: array.filter(el => el.entity_label === x)[0].a_documentoid_label,
      items: array.filter(el => el.entity_label === x),
    }));
    setArr(mdaArr);
  };

  React.useEffect(() => {
    initMda(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  return (
    <div className="w-100 h-auto">
      <Collapse in={isLoading}>
        <LinearProgress />
      </Collapse>
      <Collapse in={!isLoading}>
        {arr.length > 0 ? (
          <List className="mda_list">
            {arr.map((item, i) => (
              <div key={`key_mda_${item.entity_label}`} className="w-100">
                {i !== 0 && (
                  <Divider />
                )}
                <ListMdaItem item={item} />
              </div>
            ))}
          </List>
        ) : (
          <List dense>
            <ListItem>
              <ListItemText
                primary="Sin movimientos de almacén"
                secondary="El cliente no cuenta con movimientos de almacén"
              />
            </ListItem>
          </List>
        )}
      </Collapse>
    </div>
  );
};

ListMdaClient.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool,
};
ListMdaClient.defaultProps = {
  data: [],
  isLoading: false,
};


export default ListMdaClient;
